module.exports = {
          srcSet: __webpack_public_path__ + "4fa10e62f49e8a88f9e4f9105d48b244-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "4fa10e62f49e8a88f9e4f9105d48b244-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "4fa10e62f49e8a88f9e4f9105d48b244-60.png",
          toString:function(){return __webpack_public_path__ + "4fa10e62f49e8a88f9e4f9105d48b244-60.png"},
          
          width: 60,
          height: 60
        }